import { useEffect, useState } from "react";
import { Chart } from "react-google-charts";
import { useNavigate } from "react-router-dom";

interface MostReadAuthorsChartProps {
    library: any[]; 
}

const COLORS = ['#8884d8', '#82ca9d', '#ffc658', '#ff7f50', '#00C49F', '#FFBB28', '#FF8042'];

const options = {
    colors: COLORS,
    legend: {
        position: "none",
    },
    chartArea: {
        top: 20,
        width: '100%', // vergroot dit voor een grotere pie
        height: '80%'
    },
    bars: "horizontal",
};


const MostReadAuthorsChart: React.FC<MostReadAuthorsChartProps> = ({library}) => {
    const [formattedData, setFormattedData] = useState<any[]>([]);
    const navigate = useNavigate();

    const formatData = () => {
        const shelfCounts: Record<string, number> = library.filter(book => book["Read Count"] > 0).reduce((acc, book) => {
            const shelf = book["Author"] || "unknown"; // fallback als null
            acc[shelf] = (acc[shelf] || 0) + 1;
            return acc;
        }, {} as Record<string, number>);

        const result: [string, number][] = Object.entries(shelfCounts).map(
            ([name, value]) => [name, value]
        );

        // sort on count
        result.sort((a, b) => b[1] - a[1]);

        // top 10 authors and add other with count
        const topAuthors = result.slice(0, 10);

        // Add column headers
        const finalData: (string | number)[][] = [["", "Count"], ...topAuthors];

        setFormattedData(finalData);
    };

    useEffect(() => {
        formatData();
    }, [library]);

    if (library.length <= 0) {
        // loader
        return (
            <div className="bg-white rounded-3xl shadow-lg p-4 min-h-64 h-full mt-[40px] mb-[40px]">
                <div className="loader"></div> 
            </div>
        )
    }

      
    return(
        <div className="bg-white rounded-3xl shadow-lg p-4 min-h-64 h-full">
            <h1 className="text-2xl font-bold  text-[#60637A]">
                    Most Read Authors
            </h1>
            <div  style={{ width: '100%', height: '300px', cursor: 'pointer' }} className="pt-[20px]">
                <Chart
                    chartType="Bar"
                    data={formattedData}
                    options={options}
                    width={"100%"}
                    height={"100%"}
                    chartEvents={[
                        {
                        eventName: "select",
                        callback: ({ chartWrapper }) => {
                            const chart = chartWrapper?.getChart();
                            const selection = chart?.getSelection();

                            if (selection?.length === 0) return;

                            const selectedItem = selection?.[0];
                            const rowIndex = selectedItem?.row;

                            if (rowIndex !== null) {
                            const label = formattedData[rowIndex + 1][0]; // +1 vanwege headers

                            navigate('/stats/details?value=' + label + '&type=authors-read');
                            }
                        },
                        },
                    ]}
                />
            </div>
        </div>
    )
    
}

export default MostReadAuthorsChart